import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const CalculatedConsumablesDemand = React.lazy(() => import('.'));

export const calculatedConsumablesDemandRoutes = [
  new Route({
    path: 'calculated-consumables-demand/:planId',
    element: CalculatedConsumablesDemand,
    children: [],
  }),
];
